module.exports = __webpack_public_path__ + "img/shenghuo1.b3d9d1c8.png";